module.exports = function() {
  return new Worker(__webpack_public_path__ + "e9e41d4d7e6780074e2e.worker.js");
};